import { render, staticRenderFns } from "./permissions-row.vue?vue&type=template&id=7700e83c&scoped=true&"
import script from "./permissions-row.vue?vue&type=script&lang=js&"
export * from "./permissions-row.vue?vue&type=script&lang=js&"
import style0 from "./permissions-row.vue?vue&type=style&index=0&id=7700e83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7700e83c",
  null
  
)

export default component.exports